import React from 'react';
import {isRolesAllowed} from '../../util/cache/TimeRegistrationSettingsUtil';
import {CSS_CONSTANTS} from '../../../../css_variables';

function TimeRegistrationRolesDisplay({roles}: {roles: string[]}): JSX.Element | null {
	return isRolesAllowed() && !!roles ? (
		<div
			style={{
				display: 'inline',
				fontWeight: 'normal',
				color: `${CSS_CONSTANTS.v2_text_light_gray}`,
				overflow: 'hidden',
				whiteSpace: 'nowrap',
				textOverflow: 'ellipsis',
			}}
		>{` (Time registered as ${roles.join(', ')})`}</div>
	) : null;
}

export default TimeRegistrationRolesDisplay;
